import { useState } from "react"
import classNames from "classnames"
import JoinCard from "../components/JoinCard"
import { TotalSteps } from "../joinSteps"

interface Props {
  /** Resy's own prompt, e.g. "Hey Nina, is that you?" */
  greeting: string
  onSubmit: (email: string) => Promise<void>
  onBack: () => void
  error: string
  clearError: () => void
}

export default function EmailStep({ greeting, onSubmit, onBack, error, clearError }: Props) {
  const [email, setEmail] = useState("")
  const [sending, setSending] = useState(false)
  const valid = /\S+@\S+\.\S+/.test(email.trim())

  const submit = async () => {
    setSending(true)
    await onSubmit(email.trim())
    setSending(false)
  }

  return (
    <JoinCard
      title={greeting || "Confirm your email"}
      subtitle="Enter the email on your Resy account"
      step={3}
      totalSteps={TotalSteps}
      onBack={onBack}
      backLabel="Use a different number"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (valid && !sending) {
            submit()
          }
        }}
      >
        <label className="form-label join-label" htmlFor="email">
          Email
        </label>
        <input
          id="email"
          className={classNames("form-control form-control-lg", { "is-invalid": !!error })}
          type="email"
          autoComplete="email"
          autoFocus
          placeholder="name@example.com"
          value={email}
          disabled={sending}
          onChange={(e) => {
            setEmail(e.target.value)
            clearError()
          }}
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}

        <button
          className="btn btn-primary btn-lg w-100 mt-3"
          type="submit"
          disabled={!valid || sending}
        >
          {sending ? "Confirming..." : "Confirm"}
        </button>
      </form>
    </JoinCard>
  )
}
